import { render, staticRenderFns } from "./SampleAutoCompleteCommodity.vue?vue&type=template&id=3e6a93fa"
import script from "./SampleAutoCompleteCommodity.vue?vue&type=script&lang=js"
export * from "./SampleAutoCompleteCommodity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e6a93fa')) {
      api.createRecord('3e6a93fa', component.options)
    } else {
      api.reload('3e6a93fa', component.options)
    }
    module.hot.accept("./SampleAutoCompleteCommodity.vue?vue&type=template&id=3e6a93fa", function () {
      api.rerender('3e6a93fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleAutoCompleteCommodity.vue"
export default component.exports